function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.064 6.275A6.984 6.984 0 019.47 2.991l-.991-.866a.367.367 0 01-.036-.516l.418-.483a.363.363 0 01.514-.036l2.493 2.177a.367.367 0 01.036.516L9.737 6.287a.363.363 0 01-.514.036l-.481-.42a.367.367 0 01-.036-.516l.891-1.03a5.622 5.622 0 00-4.374 2.645 5.672 5.672 0 001.49 7.591.386.386 0 01.109.514l-.338.543a.35.35 0 01-.497.109c-3.034-2.128-3.906-6.296-1.923-9.484zM14.777 12.998a5.672 5.672 0 00-1.49-7.591.386.386 0 01-.109-.515l.338-.542a.35.35 0 01.497-.109c3.034 2.128 3.906 6.296 1.922 9.484a6.984 6.984 0 01-5.407 3.284l.992.866a.367.367 0 01.036.516l-.419.483a.363.363 0 01-.514.036L8.13 16.733a.367.367 0 01-.036-.516l2.167-2.504a.363.363 0 01.514-.036l.482.42a.367.367 0 01.036.516l-.892 1.03a5.622 5.622 0 004.376-2.645z",
  fill: "#5C6A79"
});

var SvgAgain = function SvgAgain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref);
};

export default SvgAgain;